module.exports = __webpack_public_path__ + "media/packs/public/images/mail/password_reset/android_download-8f974a0c34d134836d7043b09cf2d5cd.png";